import React, {useState} from 'react';
import styles from './404.module.css';
import { Frown } from "lucide-react";
import { openCookieSettings } from "../utils/cookieEvents";
import { openPrivacyPolicy } from "../utils/cookieEvents";
import { openCookiesPolicy } from "../utils/cookieEvents";
import CookieBanner from "../HomePage/CookieBanner";
import CookieSettings from "../HomePage/CookiesSettings";
import CookiesPolicy from "../HomePage/CookiesPolicy";
import PrivacyPolicy from "../HomePage/PrivacyPolicy";

export default function NotFound() {

  const [cookieSettings, setCookieSettings] = useState({
    analytics: false,
    marketing: false
  });
  
  return <div className={styles.content}>
      <div className={styles.icon}>
        <Frown size={48} />
      </div>
      <h1>404 - Nie znaleziono strony</h1>
      <p className={styles.notFound}>Strona, której szukasz nie istnieje.</p>

      <button className={styles.button} onClick={() => (window.location.href = "/")}>
        Powrót do strony głównej
      </button>
      <footer className={styles.footerContent}>
        <div className={styles.secondSectionOfFooter}>
          <p className={styles.sign}>
            &copy; 2025 Anna Kozak. Wszelkie prawa zastrzeżone.
          </p>
          <div className={styles.footerButton}>
            <button type="button" id="setting-cookies" className={styles.infoBtn} onClick={openCookieSettings}>
              Zmień ustawienia cookies
            </button>
            <button type="button" id="cookies-policy" className={styles.infoBtn} onClick={openCookiesPolicy}>
              Polityka cookies
            </button>
            <button type="button" id="policy-privacy" className={styles.infoBtn} onClick={openPrivacyPolicy}>
              Polityka prywatności
            </button>
          </div>
        </div>
        <CookieBanner />
        <CookieSettings settings={cookieSettings} setSettings={setCookieSettings} />
        <CookiesPolicy />
        <PrivacyPolicy />
      </footer>
    </div>;
}